import { render, staticRenderFns } from "./ScoreSetSelector.vue?vue&type=template&id=e49b121a&"
import script from "./ScoreSetSelector.vue?vue&type=script&lang=js&"
export * from "./ScoreSetSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports